import axios from 'axios'
import store from '@/store'
import { Toast } from 'vant'
let axiosInstance = axios.create({
  timeout: 5000
})


/**
 * @export
 * @param {*} config
 * @returns
 */
function axiosRequestSucessFunc (config) {
  // dosth before request
  // config.headers['Content-type'] = 'application/x-www-form-urlencoded'
   // 配置全局请求token
  if (store.getters.token) {
    config.headers['checkCode'] = store.getters.token
    config.headers['deviceId'] = store.getters.token
  }
  if (store.getters.lat && store.getters.lng) {
    config.headers['realLatitude'] = store.getters.lat
    config.headers['realLongitude'] = store.getters.lng
  }
  // 配置Headers其他参数
  
  config.headers['cityCode'] = window.systemConfig.cityCode
  config.headers['requestIds'] = window.systemConfig.requestId
  return config
}

/**
 * @export
 * @param {*} error
 * @returns
 */
export function axiosRequestFailFunc (error) {
  return Promise.reject(error)
}

/**
 * @export
 * @param {*} response
 * @returns
 */
export function axiosResponseSucessFunc (response) {
  // response by remote server
  switch (response.status) {
    case 200:
    case 304:
      const responseData = response.data
      // response success and response data
      if (responseData.code * 1 === 0 || responseData.code * 1 === 1) {
        return responseData.data || {error: false}
      } else if (responseData.code * 1 === 2 || responseData.code * 1 === 3) {
        return responseData.data || {error: false}
      } else {
        return Toast('异常情况')
      }
    default:
      return Promise.reject(response.data)
  }
}

/**
 * @export
 * @param {*} error
 * @returns
 */
export function axiosResponseFailFunc (error) {
  return Promise.reject(error)
}

// 注入request拦截器
axiosInstance.interceptors.request.use(axiosRequestSucessFunc, axiosRequestFailFunc)
// 注入response拦截器
axiosInstance.interceptors.response.use(axiosResponseSucessFunc, axiosResponseFailFunc)

export default axiosInstance
